<script lang="ts" setup>
import ModulesService from '#layers/studio/app/runtime/services/ModulesService';

defineOptions({
    name: 'ModuleDynamicModulesSettings'
});

const { $alert } = useAlerts();
const { $log } = useLogging();

const model = defineModel<any>();
const defaults: any = {
    moduleId: null,
    mode: 'list'
};
const modules = ref<Option<number>[]>([]);
const form = computed(() => model.value);

onMounted(async () =>
{
    form.value.settings = { ...defaults, ...form.value.settings };

    await loadModules();
});

watch(() => form.value?.settings, () =>
{
    model.value = form.value;
},
{ deep: true });

async function loadModules()
{
    try
    {
        const pager = new Pager(1, 10000, 'Name', 'ASC');
        const response = await ModulesService.getList({} as any, pager);

        modules.value = [{ value: null, text: '' }, ...response.items.map(p => ({
            value: p.id,
            text: p.name
        }))];
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });

        return false;
    }

    return true;
}
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Moduł konfigurowalny]]]')" :invalid-feedback="form.$errors.first('moduleId')" :state="form.$errors.state('moduleId')" required>
        <IdeoFormSelect v-model="form.settings.moduleId" type="text" name="moduleId" :options="modules" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Tryb wyświetlania]]]')" :invalid-feedback="form.$errors.first('settings.mode')" :state="form.$errors.state('settings.mode')">
        <IdeoFormRadio v-model="form.settings.mode" name="articles" value="list">
            {{ $t('[[[Lista publikacji]]]') }}
        </IdeoFormRadio>
        <IdeoFormRadio v-model="form.settings.mode" name="articles" value="single">
            {{ $t('[[[Pojedyncza publikacja]]]') }}
        </IdeoFormRadio>
    </IdeoFormGroup>
</template>
